import React from 'react';

const ErrorHandler = ({ error, onRetry, onSkip }) => {
  if (!error) return null;

  const getErrorTitle = () => {
    if (typeof error === 'string') {
      return 'Something went wrong';
    }
    return error.title || 'Error';
  };

  const getErrorMessage = () => {
    if (typeof error === 'string') {
      return error;
    }
    return error.message || 'An unexpected error occurred. Please try again.';
  };

  const getErrorDetails = () => {
    if (typeof error === 'object' && error.details) {
      return error.details;
    }
    return null;
  };

  return (
    <div className="error-container">
      <div className="error-title">{getErrorTitle()}</div>
      <div className="error-message">{getErrorMessage()}</div>
      
      {getErrorDetails() && (
        <div className="error-details">
          <details>
            <summary style={{ cursor: 'pointer', color: '#6b7280', fontSize: '14px' }}>
              Show technical details
            </summary>
            <pre style={{ 
              background: '#f9fafb', 
              padding: '12px', 
              borderRadius: '6px', 
              fontSize: '12px',
              margin: '8px 0 0 0',
              overflow: 'auto',
              maxHeight: '200px'
            }}>
              {JSON.stringify(getErrorDetails(), null, 2)}
            </pre>
          </details>
        </div>
      )}
      
      <div className="error-actions">
        {onRetry && (
          <button className="btn btn-error-retry" onClick={onRetry}>
            Try Again
          </button>
        )}
        {onSkip && (
          <button className="btn btn-error-skip" onClick={onSkip}>
            Skip This Step
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorHandler; 